// Redux
import { Action, Result } from '../index';

// Enums
import { OmniRiskProfileSteps, OmniRiskProfileStepsTitlesKeys } from '@/enums/OmniRiskProfiles';

// Types
import { OmniRiskProfileModalState } from '@/redux/modules/types/omni-risk-profiles';

// Initial State
const INITIAL_STATE: OmniRiskProfileModalState = {
  showModal: false,
};

// Actions
const GO_TO_STEP: Action = {
  type: 'connect/omni-risk-profile-modal/goToStep',
};

const RESET_QUESTIONNAIRE: Action = {
  type: 'connect/omni-risk-profile-modal/reset-questionnaire',
};

const SET_HIDE_MODAL: Action = {
  type: 'connect/omni-risk-profile-modal/hideModal',
};

const SET_IS_RENAMING_QUESTIONNAIRE: Action = {
  type: 'connect/omni-risk-profile-modal/set-is-renaming-questionnaire',
};

const SET_SHOW_MODAL: Action = {
  type: 'connect/omni-risk-profile-modal/showModal',
};

export default function reducer(state: OmniRiskProfileModalState = INITIAL_STATE, action: Action): OmniRiskProfileModalState {
  switch (action.type) {
    case GO_TO_STEP.type: {
      return {
        ...state,
        currentStep: action.step,
        currentStepTitle: action.stepTitleKey,
      };
    }
    case RESET_QUESTIONNAIRE.type: {
      return {
        ...state,
        currentStepTitle: OmniRiskProfileStepsTitlesKeys.NameRiskProfile,
        isRenamingQuestionnaire: false,
      };
    }
    case SET_HIDE_MODAL.type: {
      return {
        ...state,
        showModal: false,
      };
    }
    case SET_IS_RENAMING_QUESTIONNAIRE.type: {
      return {
        ...state,
        isRenamingQuestionnaire: action.isRenamingQuestionnaire,
      };
    }
    case SET_SHOW_MODAL.type: {
      return {
        ...state,
        showModal: true,
        currentStep: action.step,
        currentStepTitle: action.stepTitleKey,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export const goToStep =
  (step: OmniRiskProfileSteps, stepTitleKey: OmniRiskProfileStepsTitlesKeys): Result<void> =>
  dispatch => {
    dispatch({ ...GO_TO_STEP, step, stepTitleKey });
  };

export const hideModal = (): Result<void> => dispatch => {
  dispatch({ ...SET_HIDE_MODAL });
};

export const resetQuestionnaire = (): Result<void> => dispatch => {
  dispatch(RESET_QUESTIONNAIRE);
};

export const setIsRenamingQuestionnaire =
  (isRenaming = false): Result<void> =>
  dispatch => {
    dispatch({ ...SET_IS_RENAMING_QUESTIONNAIRE, isRenamingQuestionnaire: isRenaming });
  };

export const showModal =
  (step = OmniRiskProfileSteps.NAME_PROFILE, stepTitleKey = OmniRiskProfileStepsTitlesKeys.NameRiskProfile): Result<void> =>
  dispatch => {
    dispatch({ ...SET_SHOW_MODAL, step, stepTitleKey });
  };
